import {Injectable} from '@angular/core';
import {AnnualIncomeService} from '../../services/AnnualIncomeService';
import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {AssistanceApplicationType, Client} from '../../services/api.client';

@Injectable({
    providedIn: 'root',
})
export class IncomeValidatorService {

    constructor(private annualIncomeService: AnnualIncomeService) {
    }

    eligibilityScreeningIncomeValidator(programType: AssistanceApplicationType): ValidatorFn {

        return (control: AbstractControl): ValidationErrors | null => {
            const adultCountControl = control.get('adultCount');
            const childrenCountControl = control.get('childrenCount');
            const householdIncomeControl = control.get('householdIncome');


            if (!adultCountControl || !childrenCountControl || !householdIncomeControl) {
                return null;
            }

            if (adultCountControl.invalid || childrenCountControl.invalid || householdIncomeControl.invalid) {
                return null;
            }

            const householdCount = adultCountControl.value + childrenCountControl.value;
            let maxIncome = 0;
            switch (programType) {
                case AssistanceApplicationType.STLWater:
                    maxIncome = this.annualIncomeService.calculatePovertyLevelMaxAnnualStlWaterIncomeForHouseholdCount(householdCount);
                    break;
                case AssistanceApplicationType.UHONS:
                    maxIncome = this.annualIncomeService.calculatePovertyLevelMaxAnnualUhonsIncomeForHouseholdCount(householdCount);
                    break;
                default:
                    return null;
            }
            const maxMonthlyIncome = maxIncome / 12;
            const monthlyIncome = parseFloat(householdIncomeControl.value);

            if (monthlyIncome > maxMonthlyIncome) {
                return {incomeExceedsLimit: true};
            }
            return null;
        };
    }

    internalApplicationIncomeValidator(programType: AssistanceApplicationType, client: Client): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const adultControl = control.get('adults');
            const minorControl = control.get('minors');

            const householdCount = (adultControl?.value?.length ?? 0) + (minorControl.value?.length ?? 0) + 1; //Including the applicant

            let maxIncome = 0;
            switch (programType) {
                case AssistanceApplicationType.STLWater:
                    maxIncome = this.annualIncomeService.calculatePovertyLevelMaxAnnualStlWaterIncomeForHouseholdCount(householdCount);
                    break;
                case AssistanceApplicationType.UHONS:
                    maxIncome = this.annualIncomeService.calculatePovertyLevelMaxAnnualUhonsIncomeForHouseholdCount(householdCount);
                    break;
                case AssistanceApplicationType.UFF:
                    maxIncome = this.annualIncomeService.calculatePovertyLevelMaxAnnualUFFIncomeForHouseholdCount(householdCount);
                    break;
                default:
                    return null;
            }
            const maxMonthlyIncome = maxIncome / 12;
            const monthlyIncome = client?.houseHoldIncome;

            if (monthlyIncome > maxMonthlyIncome) {
                return {incomeExceedsLimit: true};
            }

            return null;
        };
    }
}
